<template>
  <div>
    <PageHeader :title="tituloPagina.title" />

    <AcompanhamentoMensalPage />
  </div>
</template>

<script lang="js">
import PageHeader from "@/components/page-header";
import AcompanhamentoMensalPage from "@/features/campanha/acompanhamento-mensal/pages/AcompanhamentoMensalPage.vue";

export default {
  name: "AcompanhamentoMensal",

  components: {
    PageHeader,
    AcompanhamentoMensalPage
  },

  data() {
    return {
      tituloPagina: {
        type: String,
        title: "Acompanhamento Mensal cooperado"
      }
    };
  }
};
</script>
